(function() {
  if (window.poshtailHeaderRuntime) return;
  window.poshtailHeaderRuntime = true;
  const { t, label } = window.PoshtailI18n;
  function syncPlannedNavigation(header) {
    const topLinks = header.querySelectorAll('[data-plan-top]');
    if (!topLinks.length) return;
    const current = new URL(window.location.href);
    const path = (value) => value.replace(/\/$/, '') || '/';
    let activeKey = '', bestScore = -1;
    header.querySelectorAll('a[data-plan-nav-key]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), current.origin);
      if (url.origin !== current.origin || path(url.pathname) !== path(current.pathname)) return;
      const params = Array.from(url.searchParams.entries());
      if (!params.every(([key, value]) => current.searchParams.getAll(key).includes(value))) return;
      const score = (link.hasAttribute('data-plan-top') ? 2 : 1) + params.length * 10;
      if (score > bestScore) { bestScore = score; activeKey = link.dataset.planNavKey; }
    });
    topLinks.forEach((link) => {
      const active = Boolean(activeKey) && link.dataset.planNavKey === activeKey;
      link.classList.toggle('active', active);
      const href = link.getAttribute('href');
      if (active && href && path(new URL(href, current.origin).pathname) === path(current.pathname)) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }
  function initHeader(header) {
    if (!header || header.dataset.headerInitialized === 'true') return;
    header.dataset.headerInitialized = 'true';
    const controller = new AbortController();
    function listen(target, type, callback) {
      target?.addEventListener(type, callback, { signal: controller.signal });
    }
    syncPlannedNavigation(header);
    listen(window, 'popstate', function() { syncPlannedNavigation(header); });
    function syncAfterCatalogInteraction(event) {
      if (!event.target.closest?.('[data-shared-catalog]')) return;
      window.requestAnimationFrame(function() { if (header.isConnected) syncPlannedNavigation(header); });
    }
    listen(document, 'change', syncAfterCatalogInteraction);
    listen(document, 'click', syncAfterCatalogInteraction);

    const toggle = header.querySelector('.wh-mobile-menu-toggle');
    const drawer = header.querySelector('.wh-drawer');
    const closeButtons = header.querySelectorAll('[data-drawer-close]');
    const mobileSubmenuToggles = header.querySelectorAll('.wh-drawer-submenu-toggle');
    const accountToggles = header.querySelectorAll('[data-account-drawer-open]');
    const accountDrawer = header.querySelector('.wh-account-drawer');
    const accountCloseButtons = header.querySelectorAll('[data-account-drawer-close]');
    const languageForm = header.querySelector('.wh-language-select');
    const languageTrigger = header.querySelector('[data-language-trigger]');
    const languageMenu = header.querySelector('[data-language-menu]');
    const languageSelect = header.querySelector('.wh-language-native');
    const languageOptions = header.querySelectorAll('[data-language-option]');
    const languageDropdown = header.querySelector('[data-language-dropdown]');
    const languageSummary = languageDropdown?.querySelector('summary');
    const languageValue = header.querySelector('[data-language-value]');
    const countrySelect = header.querySelector('.wh-country-select');
    const countryOptions = header.querySelectorAll('[data-country-option]');
    const countryStatus = header.querySelector('[data-country-status]');
    let countrySubmitTimer;
    const actualCountry = countryStatus?.dataset.currentCountry || countrySelect?.value;
    function syncCountrySelection(code) {
      const selected = Array.from(countryOptions).find((item) => item.dataset.countryOption === code);
      if (!selected) return;
      if (countrySelect) countrySelect.value = code;
      countryOptions.forEach((item) => {
        const active = item === selected;
        item.classList.toggle('is-active', active);
        if (active) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      const flag = selected.querySelector('.wh-country-flag');
      const triggerFlag = languageTrigger?.querySelector('.wh-language-trigger-icon');
      if (flag && triggerFlag) triggerFlag.replaceChildren(flag.cloneNode(true));
      const language = languageSelect?.selectedOptions?.[0]?.textContent.trim() || '';
      const current = languageTrigger?.querySelector('.wh-language-current');
      if (current) current.textContent = code + (language ? ' · ' + language : '');
      const name = selected.querySelector('.wh-country-option-name')?.textContent.trim() || code;
      const currency = selected.querySelector('.wh-country-option-currency')?.textContent.trim() || '';
      languageTrigger?.setAttribute('title', [name, currency, language].filter(Boolean).join(' · '));
    }
    function setCountryStatus(message, state) {
      if (!countryStatus) return;
      countryStatus.textContent = message;
      countryStatus.hidden = !message;
      countryStatus.dataset.state = state || '';
    }
    function checkCountryResult() {
      if (!countryStatus) return;
      let pending;
      try {
        pending = JSON.parse(sessionStorage.getItem(countryStatus.dataset.stateKey) || 'null');
        sessionStorage.removeItem(countryStatus.dataset.stateKey);
      } catch (_) { return; }
      if (!pending || Date.now() - pending.at > 30000 || !Array.from(countryOptions).some((item) => item.dataset.countryOption === pending.code)) return;
      if (pending.code !== actualCountry) {
        let message = countryStatus.dataset.failed.replace('{country}', actualCountry || '');
        if (countryStatus.dataset.editor === 'true') message += ' ' + countryStatus.dataset.previewHelp;
        setCountryStatus(message, 'error');
        setLanguageMenu(true);
      }
    }
    const desktopDropdownToggles = header.querySelectorAll('.wh-primary-nav .wh-nav-dropdown-toggle');
    const desktopNavItems = header.querySelectorAll('.wh-primary-nav .wh-nav-item');
    const searchOpenButtons = header.querySelectorAll('[data-header-search-open]');
    const searchCloseButtons = header.querySelectorAll('[data-header-search-close]');
    const searchForm = header.querySelector('.wh-search');
    const filterOpenButton = header.querySelector('[data-collection-filter-open]');
    const cartAction = header.querySelector('.wh-cart-action');
    const cartFeedback = header.querySelector('[data-cart-feedback]');
    const cartPreviewContent = header.querySelector('[data-cart-preview-content]');
    let cartFeedbackTimer;
    let cartPreviewRequest = 0;
    function renderCartPreview(cart) {
      if (!cartPreviewContent || !Array.isArray(cart?.items)) return;
      const count = Number.isInteger(cart.item_count) ? cart.item_count : cart.items.reduce(function(total, item) { return total + (item.quantity || 0); }, 0);
      cartPreviewContent.replaceChildren();
      if (!count) {
        const empty = document.createElement('div');
        empty.className = 'wh-cart-preview__empty';
        empty.innerHTML = '<svg viewBox="0 0 80 80" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 28h40l-4 41H24l-4-41Z" fill="#f5cf6b" stroke="#d7a53b"/><path d="M31 29v-9a9 9 0 0 1 18 0v9"/><path d="M31 47c4 8 14 8 18 0"/><circle cx="32" cy="41" r="1" fill="currentColor"/><circle cx="48" cy="41" r="1" fill="currentColor"/></svg>';
        const message = document.createElement('p');
        message.textContent = 'Your shopping cart is empty.';
        const shopLink = document.createElement('a');
        shopLink.href = '/collections/all';
        shopLink.textContent = 'Go shopping →';
        empty.append(message, shopLink);
        cartPreviewContent.append(empty);
        return;
      }
      const title = document.createElement('p');
      title.className = 'wh-cart-preview__title';
      title.textContent = 'Your cart · ' + count + (count === 1 ? ' item' : ' items');
      const list = document.createElement('ul');
      list.className = 'wh-cart-preview__items';
      cart.items.slice(0, 3).forEach(function(item) {
        const row = document.createElement('li');
        row.className = 'wh-cart-preview__item';
        const imageUrl = item.image || item.featured_image?.url;
        const thumb = imageUrl ? document.createElement('img') : document.createElement('span');
        if (imageUrl) {
          thumb.src = imageUrl;
          thumb.alt = '';
          thumb.width = 48;
          thumb.height = 48;
          thumb.loading = 'lazy';
        } else thumb.className = 'wh-cart-preview__item-placeholder';
        const details = document.createElement('span');
        const link = document.createElement('a');
        link.href = item.url || '/cart';
        link.textContent = item.product_title || item.title || 'Cart item';
        const quantity = document.createElement('small');
        quantity.textContent = 'Qty: ' + (item.quantity || 1);
        details.append(link, quantity);
        row.append(thumb, details);
        list.append(row);
      });
      const viewLink = document.createElement('a');
      viewLink.className = 'wh-cart-preview__view';
      viewLink.href = cartAction?.getAttribute('href') || '/cart';
      viewLink.textContent = 'View cart →';
      cartPreviewContent.append(title, list, viewLink);
    }
    async function refreshCartPreview() {
      if (!cartAction || !cartPreviewContent) return;
      const request = ++cartPreviewRequest;
      try {
        const response = await fetch(cartAction.getAttribute('href') + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (request === cartPreviewRequest && header.isConnected) renderCartPreview(cart);
      } catch (_) { /* Keep the server-rendered preview if the refresh fails. */ }
    }
    listen(cartAction?.closest('.wh-action-popover'), 'pointerenter', function(event) {
      if (event.pointerType !== 'touch' && window.matchMedia('(min-width: 901px)').matches) refreshCartPreview();
    });
    listen(cartAction, 'focus', function() {
      if (window.matchMedia('(min-width: 901px)').matches) refreshCartPreview();
    });
    function closeCartFeedback() {
      window.clearTimeout(cartFeedbackTimer);
      if (cartFeedback?.contains(document.activeElement)) cartAction?.focus();
      if (cartFeedback) cartFeedback.hidden = true;
      cartAction?.classList.remove('is-cart-added');
    }
    function positionCartFeedback() {
      if (!cartFeedback || cartFeedback.hidden) return;
      const rect = cartAction?.getBoundingClientRect();
      cartFeedback.style.right = Math.max(12, Math.min(window.innerWidth - (rect?.right || window.innerWidth - 12), window.innerWidth - cartFeedback.offsetWidth - 12)) + 'px';
      cartFeedback.style.top = (rect && rect.bottom > 0 && rect.bottom < window.innerHeight / 2 ? rect.bottom + 12 : 16) + 'px';
    }
    listen(document, 'poshtail:cart-added', async function(event) {
      if (!cartAction || !cartFeedback) return;
      let cart = event.detail?.cart;
      if (!cart) {
        try {
          const response = await fetch(cartAction.getAttribute('href') + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
          if (response.ok) cart = await response.json();
        } catch (_) { /* Keep success feedback even when the count cannot refresh. */ }
      }
      if (!cartAction.isConnected) return;
      if (Number.isInteger(cart?.item_count)) {
        let badge = cartAction.querySelector('.wh-badge');
        if (!badge) { badge = document.createElement('span'); badge.className = 'wh-badge'; cartAction.append(badge); }
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
        cartAction.setAttribute('aria-label', t('cart_count', { count: cart.item_count, label: label('cart', cart.item_count) }));
      }
      if (Array.isArray(cart?.items)) renderCartPreview(cart);
      else refreshCartPreview();
      cartFeedback.querySelector('[data-cart-feedback-count]').textContent = Number.isInteger(cart?.item_count) ? t('cart_status', { count: cart.item_count, label: label('cart', cart.item_count) }) : t('cart_fallback');
      cartFeedback.hidden = false;
      positionCartFeedback();
      cartAction.classList.remove('is-cart-added');
      void cartAction.offsetWidth;
      cartAction.classList.add('is-cart-added');
      window.clearTimeout(cartFeedbackTimer);
      cartFeedbackTimer = window.setTimeout(function() {
        if (!cartFeedback.matches(':hover, :focus-within')) closeCartFeedback();
      }, 6500);
    });
    listen(header.querySelector('[data-cart-feedback-close]'), 'click', closeCartFeedback);
    listen(document, 'keydown', function(event) { if (event.key === 'Escape') closeCartFeedback(); });
    listen(window, 'resize', positionCartFeedback);
    listen(window, 'scroll', positionCartFeedback);
    let searchReturnFocus = null;
    let drawerReturnFocus = null;
    let accountReturnFocus = null;
    let bodyOverflowBeforeLock = null;
    let hoverTimer = null;

    function clearHoverTimer() {
      window.clearTimeout(hoverTimer);
      hoverTimer = null;
    }

    function restoreFocus(target) {
      window.setTimeout(function() {
        if (!header.matches('.drawer-open, .account-drawer-open, .search-open') && target?.isConnected && target.getClientRects().length) target.focus();
      }, 0);
    }

    if (!toggle || !drawer) return;

    header._cleanupHeader = function() {
      closeCartFeedback();
      clearHoverTimer();
      setSearch(false);
      setDrawer(false);
      setAccountDrawer(false);
      setLanguageMenu(false);
      controller.abort();
      delete header.dataset.headerInitialized;
    };

    function closeDropdowns(exceptItem) {
      clearHoverTimer();
      header.querySelectorAll('.wh-nav-item.has-dropdown.is-open').forEach(function(item) {
        if (item === exceptItem) return;
        item.classList.remove('is-open');
        item.querySelector('.wh-nav-dropdown-toggle')?.setAttribute('aria-expanded', 'false');
      });
    }

    function setMobileSubmenu(item, open) {
      const submenu = item?.querySelector(':scope > ul');
      const arrowToggle = item?.querySelector('.wh-drawer-submenu-toggle');
      if (!item || !submenu) return;

      item.classList.toggle('is-open', open);
      arrowToggle?.setAttribute('aria-expanded', String(open));
      submenu.setAttribute('aria-hidden', String(!open));
      submenu.inert = !open;
      submenu.style.maxHeight = open ? submenu.scrollHeight + 'px' : '0px';
    }

    function closeMobileSubmenus(exceptItem) {
      drawer.querySelectorAll('.has-submenu.is-open').forEach(function(item) {
        if (item !== exceptItem) setMobileSubmenu(item, false);
      });
    }

    function setBodyLock() {
      const locked = header.classList.contains('drawer-open') || header.classList.contains('account-drawer-open') || header.classList.contains('search-open');
      if (locked && bodyOverflowBeforeLock === null) {
        bodyOverflowBeforeLock = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else if (!locked && bodyOverflowBeforeLock !== null) {
        document.body.style.overflow = bodyOverflowBeforeLock;
        bodyOverflowBeforeLock = null;
      }
    }

    function setSearch(open) {
      if (!searchForm || !searchOpenButtons.length) return;

      const wasOpen = header.classList.contains('search-open');

      if (open) {
        setDrawer(false);
        setAccountDrawer(false);
        setLanguageMenu(false);
        closeDropdowns();
      }

      header.classList.toggle('search-open', open);
      searchOpenButtons.forEach(function(button) {
        button.setAttribute('aria-expanded', String(open));
      });
      setBodyLock();

      if (open) {
        window.setTimeout(function() {
          if (header.isConnected && header.classList.contains('search-open')) searchForm.querySelector('input[type="search"]')?.focus();
        }, 120);
      } else if (wasOpen && searchReturnFocus && document.contains(searchReturnFocus)) {
        const returnTarget = searchReturnFocus;
        searchReturnFocus = null;
        window.setTimeout(function() {
          returnTarget.focus();
        }, 0);
      }
    }

    function setLanguageMenu(open) {
      if (!languageForm || !languageTrigger || !languageMenu) return;

      languageForm.classList.toggle('is-open', open);
      languageTrigger.setAttribute('aria-expanded', String(open));
      if (!open && languageDropdown) languageDropdown.open = false;
    }

    function resetLocalizationPending() {
      window.clearTimeout(countrySubmitTimer);
      languageForm?.classList.remove('is-submitting');
      languageForm?.removeAttribute('aria-busy');
      syncCountrySelection(actualCountry);
      if (countryStatus?.dataset.state === 'pending') setCountryStatus('', '');
    }
    function markLocalizationPending() {
      if (!languageForm || languageForm.classList.contains('is-submitting')) return false;
      languageForm.classList.add('is-submitting');
      languageForm.setAttribute('aria-busy', 'true');
      return true;
    }
    listen(window, 'pageshow', function() { resetLocalizationPending(); checkCountryResult(); });
    checkCountryResult();
    listen(languageForm, 'focusout', function(event) {
      if (event.relatedTarget && !languageForm.contains(event.relatedTarget)) setLanguageMenu(false);
    });
    listen(languageDropdown, 'keydown', function(event) {
      const options = Array.from(languageOptions);
      const current = options.indexOf(document.activeElement);
      if (event.key === 'Escape' && languageDropdown.open) {
        event.preventDefault();
        event.stopPropagation();
        languageDropdown.open = false;
        languageSummary?.focus();
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) || !options.length) return;
      event.preventDefault();
      languageDropdown.open = true;
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : event.key === 'ArrowDown' ? (current + 1) % options.length : (current < 0 ? options.length - 1 : (current - 1 + options.length) % options.length);
      options[next].focus();
    });

    mobileSubmenuToggles.forEach(function(button) {
      const item = button.closest('.has-submenu');
      setMobileSubmenu(item, false);
      const submenu = item?.querySelector(':scope > ul');
      if (submenu?.id) button.setAttribute('aria-controls', submenu.id);
      listen(button, 'click', function() {
        const item = button.closest('.has-submenu');
        if (!item) return;

        const open = !item.classList.contains('is-open');
        if (open) closeMobileSubmenus(item);
        setMobileSubmenu(item, open);
      });
    });

    listen(languageTrigger, 'click', function() {
      setLanguageMenu(!languageForm.classList.contains('is-open'));
      closeDropdowns();
    });

    languageOptions.forEach(function(option) {
      listen(option, 'click', function() {
        if (!languageSelect || !languageForm) return;
        if (languageSelect.value === option.dataset.languageOption) {
          if (languageDropdown) languageDropdown.open = false;
          languageSummary?.focus();
          return;
        }
        if (!markLocalizationPending()) return;
        if (languageValue) languageValue.textContent = option.querySelector('.wh-language-option-name')?.textContent.trim() || option.textContent.trim();
        languageOptions.forEach(function(item) {
          const active = item === option;
          item.classList.toggle('is-active', active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        languageSelect.value = option.dataset.languageOption;
        languageSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    countryOptions.forEach(function(option) {
      listen(option, 'click', function() {
        if (!countrySelect || !languageForm) return;
        if (countrySelect.value === option.dataset.countryOption) return;
        if (!markLocalizationPending()) return;
        const code = option.dataset.countryOption;
        syncCountrySelection(code);
        setCountryStatus(countryStatus?.dataset.switching || '', 'pending');
        countrySubmitTimer = window.setTimeout(function() {
          if (!header.isConnected) return;
          try {
            if (countryStatus) sessionStorage.setItem(countryStatus.dataset.stateKey, JSON.stringify({ code, at: Date.now() }));
          } catch (_) { /* Country switching still works without optional feedback storage. */ }
          countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
        }, 180);
      });
    });

    desktopDropdownToggles.forEach(function(button) {
      listen(button, 'click', function(event) {
        if (window.matchMedia('(max-width: 1400px)').matches) return;

        // Shop all is a navigation link; hover/focus still opens its mega menu.
        if (button.hasAttribute('data-header-navigation-link')) {
          closeDropdowns();
          setLanguageMenu(false);
          return;
        }

        event.preventDefault();
        const item = button.closest('.wh-nav-item.has-dropdown');
        if (!item) return;

        const open = !item.classList.contains('is-open');
        closeDropdowns();
        setLanguageMenu(false);
        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
      });
    });

    desktopNavItems.forEach(function(item) {
      function closeCompetingItems() {
        if (window.matchMedia('(max-width: 1400px)').matches) return;
        closeDropdowns(item.classList.contains('has-dropdown') ? item : null);
        setLanguageMenu(false);
      }

      listen(item, 'pointerenter', function(event) {
        if (event.pointerType === 'touch' || window.matchMedia('(max-width: 1400px)').matches) return;
        clearHoverTimer();
        function openHoveredItem() {
          closeCompetingItems();
          if (!item.classList.contains('has-dropdown')) return;
          item.classList.add('is-open');
          item.querySelector('.wh-nav-dropdown-toggle')?.setAttribute('aria-expanded', 'true');
        }
        // Allow a diagonal path across neighbouring links into an open mega menu.
        const openItem = header.querySelector('.wh-primary-nav .has-dropdown.is-open');
        if (openItem && openItem !== item) hoverTimer = window.setTimeout(openHoveredItem, 120);
        else openHoveredItem();
      });
      listen(item, 'pointerleave', function() {
        clearHoverTimer();
        if (item.contains(document.activeElement)) return;
        hoverTimer = window.setTimeout(function() {
          const activeItem = header.querySelector('.wh-primary-nav .has-dropdown.is-open');
          if (activeItem && (activeItem.matches(':hover') || activeItem.contains(document.activeElement))) return;
          closeDropdowns();
        }, 140);
      });
      listen(item, 'focusin', function(event) {
        closeCompetingItems();
        if (!event.target.matches(':focus-visible')) return;
        if (!item.classList.contains('has-dropdown')) return;
        item.classList.add('is-open');
        item.querySelector('.wh-nav-dropdown-toggle')?.setAttribute('aria-expanded', 'true');
      });
      listen(item, 'focusout', function(event) {
        if (item.contains(event.relatedTarget)) return;
        window.setTimeout(function() {
          if (!item.contains(document.activeElement) && !item.matches(':hover')) {
            item.classList.remove('is-open');
            item.querySelector('.wh-nav-dropdown-toggle')?.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });

    listen(window, 'resize', function() {
      if (window.matchMedia('(max-width: 1400px)').matches) closeDropdowns();
      if (!window.matchMedia('(max-width: 1400px)').matches && header.classList.contains('drawer-open')) setDrawer(false);
      drawer.querySelectorAll('.has-submenu.is-open > ul').forEach(function(submenu) {
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      });
    });

    function setDrawer(open) {
      const wasOpen = header.classList.contains('drawer-open');
      if (open && !wasOpen) drawerReturnFocus = document.activeElement;
      if (open) setAccountDrawer(false);
      if (open) setLanguageMenu(false);
      if (open) setSearch(false);
      header.classList.toggle('drawer-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('aria-hidden', String(!open));
      drawer.inert = !open;
      setBodyLock();
      if (open) {
        window.setTimeout(function() {
          if (header.isConnected && header.classList.contains('drawer-open')) drawer.querySelector('[data-drawer-close]')?.focus();
        }, 120);
      } else if (wasOpen) restoreFocus(drawerReturnFocus);
    }

    function setAccountDrawer(open) {
      if (!accountDrawer) return;
      const wasOpen = header.classList.contains('account-drawer-open');
      if (open && !wasOpen) accountReturnFocus = document.activeElement;

      if (open) {
        setDrawer(false);
        closeDropdowns();
        setLanguageMenu(false);
        setSearch(false);
      }

      header.classList.toggle('account-drawer-open', open);
      accountDrawer.setAttribute('aria-hidden', String(!open));
      accountDrawer.inert = !open;
      accountToggles.forEach(function(button) { button.setAttribute('aria-expanded', String(open)); });
      setBodyLock();

      if (open) {
        const focusTarget = accountDrawer.querySelector('input, .wh-account-submit, .wh-account-secondary, .wh-account-menu a, button');
        window.setTimeout(function() {
          if (header.isConnected && header.classList.contains('account-drawer-open')) focusTarget?.focus();
        }, 180);
      } else if (wasOpen) restoreFocus(accountReturnFocus);
    }

    listen(toggle, 'click', function() {
      setDrawer(!header.classList.contains('drawer-open'));
    });

    searchOpenButtons.forEach(function(button) {
      listen(button, 'click', function() {
        searchReturnFocus = button;
        setSearch(!header.classList.contains('search-open'));
      });
    });

    searchCloseButtons.forEach(function(button) {
      listen(button, 'click', function() {
        setSearch(false);
      });
    });

    listen(filterOpenButton, 'click', function() {
      setSearch(false);
      setDrawer(false);
      setAccountDrawer(false);
      setLanguageMenu(false);
      window.dispatchEvent(new CustomEvent('pbrand:openCollectionFilters'));
    });

    listen(window, 'pbrand:collectionFiltersState', function(event) {
      filterOpenButton?.setAttribute('aria-expanded', String(Boolean(event.detail && event.detail.open)));
    });

    closeButtons.forEach(function(button) {
      listen(button, 'click', function() {
        setDrawer(false);
      });
    });

    accountToggles.forEach(function(button) {
      listen(button, 'click', function(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        setAccountDrawer(true);
      });
    });

    accountCloseButtons.forEach(function(button) {
      listen(button, 'click', function() {
        setAccountDrawer(false);
      });
    });

    listen(document, 'click', function(event) {
      if (!header.contains(event.target)) {
        closeDropdowns();
        setLanguageMenu(false);
      } else if (languageForm && !languageForm.contains(event.target)) {
        setLanguageMenu(false);
      }
    });

    drawer.querySelectorAll('a').forEach(function(link) {
      listen(link, 'click', function() {
        setDrawer(false);
      });
    });

    listen(document, 'keydown', function(event) {
      if (event.key === 'Tab') {
        const panel = header.classList.contains('drawer-open') ? drawer : header.classList.contains('account-drawer-open') ? accountDrawer : header.classList.contains('search-open') ? searchForm : null;
        if (panel) {
          const focusable = Array.from(panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(function(el) {
            return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
          });
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (first && (!panel.contains(document.activeElement) || (event.shiftKey ? document.activeElement === first : document.activeElement === last))) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
          }
        }
        return;
      }
      if (event.key !== 'Escape') return;

      if (document.activeElement?.closest('.wh-action-popover') && !header.matches('.drawer-open, .account-drawer-open, .search-open')) {
        document.activeElement.blur();
      }

      const focusedDropdown = document.activeElement?.closest('.wh-nav-item.is-open');
      if (focusedDropdown?.querySelector('.wh-nav-dropdown')?.contains(document.activeElement)) {
        focusedDropdown.querySelector('.wh-nav-dropdown-toggle')?.focus();
      }

      if (header.classList.contains('drawer-open')) {
        setDrawer(false);
      }

      if (header.classList.contains('account-drawer-open')) {
        setAccountDrawer(false);
      }

      if (header.classList.contains('search-open')) {
        setSearch(false);
      }

      if (languageForm?.classList.contains('is-open') && languageMenu?.contains(document.activeElement)) languageTrigger?.focus();
      setLanguageMenu(false);
      closeDropdowns();
    });
  }
  function initWithin(root) {
    root.querySelectorAll('[data-poshtail-header]').forEach(initHeader);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initWithin(document); }, { once: true });
  } else {
    initWithin(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initWithin(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    event.target.querySelectorAll('[data-poshtail-header]').forEach(function(header) { header._cleanupHeader?.(); });
  });
})();
